import { LitElement, html, css } from 'lit';
import {unsafeHTML} from 'lit-html/directives/unsafe-html.js';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';
@customElement('rapport-maincontent-element')
export class RapportMaincontentElement extends JobindsatsElement(LitElement) {
    static styles = [css`
        .accordion-button {
            background-color: #0000;
            text-align: left;
            display: flex;
            border: none;
            width: 100%;
            width: initial;
            padding: 0px;
        }
        .option-group {
            display: flex;
            flex-direction: row;
            color: var(--main-blue);
            margin-top: 12px;
        }
        .margin-auto {
            margin: auto;
        }
        .more-info {
            margin-top: 0px;
        }
        .more-info-option-group-up {
            margin-top: 0px;
            padding-bottom: 4px;
        }
        .more-info-option-group-down {
            margin-top: 0px;
            padding-bottom: 10px;
        }
`];

    static instance = 0;

    @property({
        attribute: 'id',
    })
    id = ++RapportMaincontentElement.instance + 'lit-accordion';

    @state()
    expanded = false;

    @property()
    content?: string;

    @property()
    closedTitle?: string;

    @property()
    expandedTitle?: string;

   constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    render() {
        if (this.content) {
             return html`
            <div>
                <button @click=${this.toggleAccordion} class="accordion-button" aria-expanded="${this.expanded}" aria-controls="${this.id}">
                    <div class="option-group more-info-option-group-${this.expanded ? 'up' : 'down'}">
                        <a class="margin-auto more-info">${this.expanded ? this.expandedTitle : this.closedTitle}<span class="icon-right glyphicon glyphicon-menu-${this.expanded ? 'up' : 'down'}"></span></a>
                    </div>
                </button>
            </div>
            <div id="${this.id}" ?hidden=${!this.expanded} class="accordion-content">
            ${unsafeHTML(this.content)}
        `;
        }
       
    }

    toggleAccordion() {
        this.expanded = !this.expanded;
    }
}